import { CircleHelp } from 'lucide-react';
import { useI18nContext } from '@/i18n/i18n-react';
import { cn } from '@/lib/utils';
import { useHelpPanel } from './help-panel-context';

export interface HelpIconButtonProps {
  helpKey: string;
  className?: string;
  id?: string;
}

export function HelpIconButton({
  helpKey,
  className,
  id,
}: HelpIconButtonProps) {
  const { LL } = useI18nContext();
  const { activeHelpKey, openHelp } = useHelpPanel();
  const isActive = activeHelpKey === helpKey;

  return (
    <button
      id={id}
      type="button"
      aria-label={LL.metricsPage.help.ariaLabel()}
      aria-expanded={isActive}
      aria-controls="analytics-help-panel"
      onClick={() => openHelp(helpKey)}
      className={cn(
        'inline-flex size-7 shrink-0 items-center justify-center rounded-full text-muted-foreground transition-colors hover:bg-muted hover:text-foreground',
        isActive && 'bg-muted text-foreground',
        className
      )}
    >
      <CircleHelp className="h-4 w-4" />
    </button>
  );
}
